"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Backblaze = /*#__PURE__*/ _interop_require_default(require("./Backblaze"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let BackblazePlugin = class BackblazePlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return BackblazePlugin.storageAdapter;
    }
    async init(config) {
        BackblazePlugin.storageAdapter = new _Backblaze.default(config);
        await BackblazePlugin.storageAdapter.init();
    }
};
const _default = BackblazePlugin;
